import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    PUSH: createAction('GLOBAL/GLOBAL_ERROR/PUSH'),
    TOGGLE_OFF: createAction('GLOBAL/GLOBAL_ERROR/TOGGLE_OFF'),
    CLEAR_DATA: createAction('GLOBAL/GLOBAL_ERROR/CLEAR_DATA'),
};
export const initialState = Map({
    active: false,
    title: null,
    body: null,
    exceptionId: null,
    errorCode: null,
});
const reducer = handleActions({
    [actions.PUSH]: (state, action) => state.merge(Object.assign({ active: true }, action.payload)),
    [actions.TOGGLE_OFF]: (state) => state.merge({
        active: false,
    }),
    [actions.CLEAR_DATA]: () => initialState,
}, initialState);
export default reducer;
